import {
	IonLabel,
	IonIcon,
	IonAccordion,
	IonItem,
	IonAccordionGroup
} from "@ionic/react";
import {
	checkmarkCircleOutline,
	checkmarkOutline,
	closeOutline
} from "ionicons/icons";
import { useTranslation } from "react-i18next";
import Utils from "../utils/utils";

function PropertyListItemMonths({ months, future }: any) {
	const { t } = useTranslation();
	return months?.length <= 0 ? (
		<></>
	) : (
		<IonAccordionGroup>
			<IonAccordion>
				<IonItem slot="header" color="light">
					<IonLabel>{t("paymentHistory")}</IonLabel>
				</IonItem>
				<div
					slot="content"
					style={{
						maxHeight: 200,
						overflowY: "auto",
						padding: 0,
						margin: 0
					}}
				>
					{future && (
						<IonItem>
							<IonLabel>
								<div>{t("futurePayments")}</div>
								<div style={{ fontSize: 12, color: "green" }}>
									{t("currencySymbol")}
									{Utils.formatToCurrency(future)}
								</div>
							</IonLabel>
							<IonIcon
								style={{ color: "green" }}
								size="medium"
								icon={checkmarkCircleOutline}
								slot="end"
							/>
						</IonItem>
					)}
					{months?.map((month: any, i: number) => (
						<IonItem key={i}>
							<IonLabel>
								<div>
									{t(month.short)} {month.year}
								</div>
								<div style={{ fontSize: 12, color: "grey" }}>
									{/* {month.span} */}
									{t(month.dayStart)}{" "}
									{t(month.shortSpanStart)} {t("toSmall")}{" "}
									{t(month.dayEnd)} {t(month.shortSpanEnd)}{" "}
									{t(month.year)}
								</div>
								<div
									style={{ fontSize: 12, color: "black" }}
									className="ion-text-wrap"
								>
									{t("paid")}: {t("currencySymbol")}
									{Utils.formatToCurrency(month.amount)}
									{month.remaining > 0 && (
										<>
											, {t("remaining")}:{" "}
											<span style={{ color: "#EB445A" }}>
												{t("currencySymbol")}
												{Utils.formatToCurrency(
													month.remaining
												)}
											</span>
										</>
									)}
									{month.extra > 0 && (
										<>
											, {t("extra")}:{" "}
											<span style={{ color: "green" }}>
												{t("currencySymbol")}
												{Utils.formatToCurrency(
													month.extra
												)}
											</span>
										</>
									)}
								</div>
							</IonLabel>
							{month.clear ? (
								<IonIcon
									style={{ color: "green" }}
									size="medium"
									icon={checkmarkOutline}
									slot="end"
								/>
							) : (
								<IonIcon
									style={{ color: "#EB445A" }}
									icon={closeOutline}
									size="medium"
									slot="end"
								/>
							)}
						</IonItem>
					))}
				</div>
			</IonAccordion>
		</IonAccordionGroup>
	);
}

export default PropertyListItemMonths;
